import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from 'reactstrap';

export interface BadgeStateProps {
  genderContext?: 'male' | 'female';
  status: boolean | null | 'approved' | 'rejected' | 'pending';
}
export default function BadgeState({ status, genderContext }: BadgeStateProps) {
  const { t } = useTranslation();
  const texts = useMemo(() => {
    return {
      pending: t('common:approvalStatus.pending', { context: genderContext }),
      approved: t('common:approvalStatus.approved', { context: genderContext }),
      rejected: t('common:approvalStatus.rejected', { context: genderContext }),
    };
  }, [t, genderContext]);

  const colors = useMemo(() => {
    return {
      pending: '#FFE6A1',
      approved: '#CEF0DA',
      rejected: '#F2C0BD',
    };
  }, []);

  const statusWord = useMemo(() => {
    if (typeof status === 'string') {
      return status;
    }
    if (status === true) {
      return 'approved';
    } else if (status === false) {
      return 'rejected';
    } else {
      return 'pending';
    }
  }, [status]);

  return (
    <>
      <div className="d-flex align-items-center justify-content-center">
        <Badge
          className="fs-14 fw-400 py-2 px-2 text-dark"
          style={{ backgroundColor: colors[statusWord], width: '90px' }}
          pill
        >
          {texts[statusWord]}
        </Badge>
      </div>
    </>
  );
}
